import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { authHeader } from "helpers/auth-header";
import { InformacionGeneralPersonalAprobar } from "./PersonalAprobar";
import axios from "axios";
import configData from "config.json";
import { PersonalAprobarDetalleMarcacion, 
 } from "./TypePersonalAprobarMarcacion";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { DetalleMarcacionesServidor, TablaDetalleES } from "components/UsuarioGeneral/Registro Entrada Salida/typesRegistroEntradaSalida";
import { SumarDiasFecha } from "../../../../functions/DatesFunctions";


const URL_CONTROLADOR = `${configData.SERVER_URL}RegistroEntradaSalida`;
const URL_CONSULTA_PERSONAL_APROBAR = `${URL_CONTROLADOR}/PersonalAprobarMarcaciones`;
const URL_CONSULTA_DETALLE_MARCACION_SERVIDOR = `${URL_CONTROLADOR}/DetalleMarcacionesServidor`;


export async function ObtenerListadoServidores(month?:number) {

    var respuesta: ResponseRequestGeneric<InformacionGeneralPersonalAprobar> = {
        status: -1
    }

    const monthConsulta = month ? month : 0;
    const URLCOMPLETA = `${URL_CONSULTA_PERSONAL_APROBAR}/${monthConsulta}`

    try {
        const respuestaListado = await axios.get(URLCOMPLETA, {
            headers: authHeader()
        })
        respuesta.status = respuestaListado.status;


        const informacion: InformacionGeneralPersonalAprobar = respuestaListado.data;



        respuesta.dataResponse = informacion


    } catch (error) {
        respuesta =  hadleAxiosErrorResponse(error);
    }

    return respuesta;
}



export async function ObtenerDetallesServidor(idPersona:number,month:number,year:number) {

    var respuesta: ResponseRequestGeneric<DetalleMarcacionesServidor> = {
        status: -1
    }

    try {
        const fechaActual = new Date();
        var fechaQuery = fechaActual.toISOString();
        if (fechaActual.getMonth()+1 === month && fechaActual.getFullYear() === year) {
            
            fechaQuery = `${fechaActual.getFullYear()}-${fechaActual.getMonth()+1}-${fechaActual.getDate()}`

        }
        else {
            const nextMonthFirstDay = new Date(year, month , 1);
            // Subtract one day to get the last day of the desired month
            const lastDay = new Date(SumarDiasFecha(nextMonthFirstDay, -1));
            fechaQuery = `${lastDay.getFullYear()}-${lastDay.getMonth()+1}-${lastDay.getDate()}`


        }

        const respuestaListado = await axios.get(`${URL_CONSULTA_DETALLE_MARCACION_SERVIDOR}/${idPersona}?fecha=${fechaQuery}`, {
            headers: authHeader()
        })
        respuesta.status = respuestaListado.status;


        const informacion: DetalleMarcacionesServidor = respuestaListado.data;



        respuesta.dataResponse = informacion


    } catch (error) {
        respuesta =  hadleAxiosErrorResponse(error);
    }

    return respuesta;
}